module.exports = __webpack_public_path__ + "static/media/inventory-clearance-event-large-cta.72addea9.jpg";